<!-- 由 suu 创建于 2021-08-16 星期一 -->
<template>
  <div
    class="WeCitySelect"
    :class="{ 'WeCitySelect-onlycity': from != 'subscribe' }"
  >
    <!-- 城市 时间段选择 -->
    <div class="cs-region">
      <div class="re-item" @click="showCitySe = true">
        <div class="i-title" v-if="from == 'subscribe'">城市</div>
        <div class="i-cent">{{ showCitySe ? '请选择' : curCity.cityname }}</div>
        <van-icon
          class="i-icon"
          :class="{ 'i-icon-on': showCitySe }"
          name="play"
        />
      </div>
      <div
        class="re-item"
        v-if="from == 'subscribe'"
        @click="showTimeSe = true"
      >
        <div class="i-title">时段</div>
        <div class="i-cent">
          {{
            tempTime.length <= 0
              ? '请选择'
              : tempTime.length == 1
              ? tempTime[0]
              : tempTime.length + '个时间段'
          }}
        </div>
        <van-icon
          class="i-icon"
          :class="{ 'i-icon-on': showTimeSe }"
          name="play"
        />
      </div>
    </div>
    <!-- 城市选择 -->
    <van-action-sheet v-model="showCitySe">
      <div class="cs-se">
        <!-- 标题 -->
        <div class="se-title">
          <div class="title-left">选择城市</div>
        </div>
        <!-- 城市列表 -->
        <div class="se-city">
          <div
            @click="onCitySe(item)"
            class="ct-item user-btn"
            :class="{ 'ct-item-ac': item.region_id == curCity.region_id }"
            v-for="(item, index) in citys"
            :key="index"
          >
            <div class="i-left">
              {{ item.cityname }}<span>{{ item.shop_count }}</span>
            </div>
            <van-icon class="i-right" name="success" />
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!-- 时间段选择 -->
    <van-action-sheet v-model="showTimeSe">
      <div class="cs-se">
        <!-- 标题 -->
        <div class="se-title">
          <div class="title-left">选择时间段</div>
          <div class="title-right user-btn" @click="timeConfrim">确定</div>
        </div>
        <!-- 时间段列表 -->
        <div class="se-time">
          <div
            @click="onTimeSe(item)"
            class="time-item"
            :class="{ 'time-item-ac': curSelectTime.indexOf(item) != -1 }"
            v-for="(item, index) in timeList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="se-tips">选择时间后，将不显示无课教练</div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'WeCitySelect',

  components: {},

  props: {
    from: {}
  },

  data() {
    return {
      curSelectTime: [],
      showTimeSe: false, // 弹出时间选择
      showCitySe: false, // 弹出城市选择
      timeList: [
        '06:00-07:00',
        '07:00-08:00',
        '08:00-09:00',
        '09:00-10:00',
        '10:00-11:00',
        '11:00-12:00',
        '12:00-13:00',
        '13:00-14:00',
        '14:00-15:00',
        '15:00-16:00',
        '16:00-17:00',
        '17:00-18:00',
        '18:00-19:00',
        '19:00-20:00',
        '20:00-21:00',
        '21:00-22:00',
        '22:00-23:00',
        '不限'
      ]
    }
  },

  computed: {
    citys() {
      //  城市列表
      return this.$store.state.user.user.citys || null
    },
    curCity() {
      //  当前城市
      // console.log('this.$store.state.subscribe.dayinfo:', this.$store.state.subscribe.dayinfo)
      return this.$store.state.curCity
    },
    tempTime() {
      //当前选择的时间段
      return this.$store.state.subscribe.curTime
    }
  },

  watch: {},

  created() {
    this.curSelectTime = this.$store.state.subscribe.curTime
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 确认时间选择
     */
    timeConfrim() {
      // 如果跟之前不等 则赋值重新请求
      // if (
      //   JSON.stringify(this.tempTime) !=
      //   JSON.stringify(this.$store.state.subscribe.curTime)
      // ) {
      //   }
      this.$store.commit('setCurTime', this.curSelectTime)
      this.$emit('timeSelect')
      this.showTimeSe = false
    },
    /**
     * 选择时段
     */
    onTimeSe(time) {
      let i = this.curSelectTime.indexOf(time)
      let temp = JSON.parse(JSON.stringify(this.curSelectTime))
      if (i !== -1) {
        temp.splice(i, 1)
      } else {
        temp.push(time)
      }
      if (this.curSelectTime.indexOf('不限') === -1 && time === '不限') {
        temp = ['不限']
      }
      if (this.curSelectTime.indexOf('不限') !== -1 && time !== '不限') {
        temp = [time]
      }
      this.curSelectTime = temp
      this.$forceUpdate()
    },
    /**
     * 点击选择城市
     */
    onCitySe(item) {
      if (item.region_id === this.curCity.region_id) {
        this.showCitySe = false
        return
      }
      // const location = this.$store.state.location;
      // let lat = location && location.lat;
      // let lng = location && location.lng;
      this.$store.commit('setCurCity', item)
      // 重置时间段
      this.$store.commit('setCurTime', [])
      this.curSelectTime = []
      this.$toast.loading('切换城市中···')
      if (this.from === 'subscribe') {
        this.$emit('citySelect')
        this.$http.userinfo('', '', item.region_id)
      } else {
        this.$http.homeinfo('', '', item.region_id)
        this.$http.userinfo('', '', item.region_id)
      }
      this.showCitySe = false
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.WeCitySelect {
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  padding: 1vw 4vw;
  padding-bottom: 4.3vw;
  .cs-region {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .re-item {
      width: 44.5vw;
      height: 9.9vw;
      background-color: #ffffff;
      border-radius: 1.1vw;
      border: solid 0.3vw #f1f1f1;
      display: flex;
      align-items: center;
      padding: 0 2.7vw;
      box-sizing: border-box;
      font-size: 3.5vw;
      .i-title {
        color: rgba(0, 0, 0, 0.5);
      }
      .i-cent {
        flex: 1;
        margin: 0 2.7vw;
        font-weight: 450;
        color: #000000;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .i-icon {
        color: #bbb;
        font-size: 2.4vw;
        transition: all 0.5s;
        transform: rotate(90deg);
      }
      .i-icon-on {
        transform: rotate(-90deg);
      }
    }
    .re-item + .re-item {
      margin-left: 2.4vw;
    }
  }
  .cs-se {
    width: 100%;
    box-sizing: border-box;
    padding: 5.3vw;
    background-color: #f9f9f9;
    .se-title {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-left {
        font-size: 4vw;
        font-weight: 450;
        color: #000000;
      }
      .title-right {
        width: 16vw;
        height: 7.2vw;
        background-color: #f04646;
        border-radius: 1.6vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4vw;
        font-weight: 600;
        color: #ffffff;
      }
    }
    .se-city {
      width: 100%;
      box-sizing: border-box;
      margin-top: 3.5vw;
      .ct-item {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 11.7vw;
        background-color: #ffffff;
        border-radius: 2.7vw;
        padding: 3.2vw 5.3vw;
        font-size: 3.7vw;
        color: #000;
        margin-top: 2.7vw;
        font-weight: 600;
        .i-left {
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 3.2vw;
            color: rgba(0, 0, 0, 0.3);
            margin-left: 3.2vw;
          }
        }
        .i-right {
          display: none;
        }
      }
      .ct-item-ac {
        color: $weRed;
        .i-right {
          display: block;
        }
      }
    }
    .se-time {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 1vw;
      .time-item {
        width: 28vw;
        height: 10.7vw;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 1.6vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 3.5vw;
        color: #000000;
        margin-top: 2.7vw;
      }
      .time-item-ac {
        color: $weRed;
        border: solid 0.3vw $weRed;
      }
    }
    .se-tips {
      font-size: 3.2vw;
      color: #000000;
      margin-top: 2.9vw;
      text-align: center;
    }
  }
}
.WeCitySelect-onlycity {
  width: vw(343);
  height: vw(36);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: #fff;
  // text-align: center;
  color: #000;
  font-size: vw(16);
  font-weight: 500;
  padding: 0 vw(16);
  border-radius: vw(4);
  margin: 0 auto;
  .cs-region {
    .re-item {
      border: none;
      width: auto;
    }
  }
}
</style>
